import { gql, type OperationVariables } from '@apollo/client';

import GraphQL from '../graphQL';

const query = gql`
mutation companyEmailSettingsSendMail($test: Boolean!, $forecastText: String, $sendForecastMail: Boolean, $sendUpdateReminderMail: Boolean) {
    companyEmailSettingsSendMail(test: $test, forecastText: $forecastText, sendForecastMail: $sendForecastMail, sendUpdateReminderMail: $sendUpdateReminderMail)
},
`;

export default async function companyEmailSettingsSendMail(
    test: boolean,
    forecastText?: string,
    sendForecastMail?: boolean,
    sendUpdateReminderMail?: boolean,
) {
    const variables: OperationVariables = {
        test,
        forecastText,
        sendForecastMail,
        sendUpdateReminderMail,
    };
    return GraphQL.mutate<boolean>(query, variables);
}
